import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { getBriefData } from "../services/api";

import { useConsultation } from "../context/useConsultation";
import { captureAppException } from "../sentry";

export const useFetchBriefing = () => {
  const { t, i18n } = useTranslation();
  const { scoreData, setBriefData, setModalConfig } = useConsultation();

  const fetchBriefing = useCallback(async () => {
    if (!scoreData) return;

    try {
      const requestedLang = new URLSearchParams(window.location.search).get(
        "lang",
      );
      const briefingLang = requestedLang || i18n.resolvedLanguage || i18n.language;

      const data = await getBriefData(briefingLang);
      if (!data.audio_url) {
        setModalConfig({
          isOpen: true,
          title: t("errorOccurred"),
          message: t("audioIsNotReady"),
          showProgress: false,
          type: "alert",
        });
        return;
      }
      setBriefData(data);
      return data;
    } catch (err: unknown) {
      captureAppException(err, {
        tags: { feature: "briefing" },
        extra: { requestedLang: i18n.resolvedLanguage || i18n.language },
      });
      const errMsg =
        err instanceof Error ? err.message : t("briefingLoadFailed");
      setModalConfig({
        isOpen: true,
        title: t("errorOccurred"),
        message: errMsg,
        showProgress: false,
        type: "alert",
      });
    }
  }, [i18n.language, i18n.resolvedLanguage, scoreData, setBriefData, setModalConfig, t]);


  return { fetchBriefing };
};
